// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__GqKsN","primaryBtn":"Button_primaryBtn__xTL3R"};